import React from "react";
import axios from "axios";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { DropdownButton, Dropdown, Navbar, Nav } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { logout, isAuthenticated } from "../../utils/auth/auth";
import logo from "../../assets/logo_info.png";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./NavBarRosa.Module.css";
import { setUserInfo, clearInfo } from "../../features-slice/user/userSlice";
import { isEditMode } from "../../utils/users/users";
import { useMediaQuery } from "react-responsive";

function NavBarRosa() {
  const isSmallScreen = useMediaQuery({ maxWidth: 1400 });
  const user = useSelector((state) => state.user.userInfo);
  const idUsuario = localStorage.getItem("Usuario");
  const [editMode, setEditMode] = React.useState(false);

  const dispatch = useDispatch();
  const location = useLocation();

  /* ===== ACTIVE STATES ===== */
  const isInicio =
    location.pathname === "/" || location.pathname === "/landing";

  const isBeautisalon = location.pathname.startsWith("/cartilla");

  const isBeautiComunidad = location.pathname.startsWith("/alianzas");

  const isContacto = location.pathname.startsWith("/contacto");

  /* ===== Dropdown Beautisalon ===== */
  const [showBeautisalon, setShowBeautisalon] = React.useState(false);

  const cerrarSesion = (e) => {
    e.preventDefault();
    window.location.replace("/");
    setTimeout(() => dispatch(clearInfo()), 1500);
    logout();
  };

  const titleDrop = () => {
    if (user.role !== "ADMIN_ROLE" && user.role !== "SUPERADMIN_ROLE") {
      return (
        <div className="dropdowncito2">
          <i className="bi bi-gem"></i>
          {user?.puntosAcumulados ?? "0"}
        </div>
      );
    }
    return (
      <div className="dropdowncito">
        <p className="titleDrop">ADMIN</p>
      </div>
    );
  };

  React.useEffect(() => {
    const checkEdit = async () => {
      const rta = await isEditMode();
      setEditMode(rta);
    };
    checkEdit();
  }, []);

  React.useEffect(() => {
    if (isAuthenticated() && !user.role) {
      const recargarEstado = async () => {
        try {
          const userQuery = await axios.get(
            `${process.env.REACT_APP_BACK_URL}/api/usuarios/${idUsuario}`
          );
          dispatch(setUserInfo(userQuery.data));
        } catch (e) {
          console.log(e);
        }
      };
      recargarEstado();
    }
  }, [user]);

  return (
    <div className="navbar navbar-expand-md border-bottom divNavBarRosa">
      <Navbar expand="lg" className="container-fluid navbaaar">
        <Navbar.Brand
          href="/"
          style={{ width: isSmallScreen && "20vw" }}
          className="logoRosa"
        >
          <img src={logo} alt="Logo La Beautiquería" />
        </Navbar.Brand>

        <Navbar.Toggle
          className="custom-toggle-image"
          aria-controls="basic-navbar-nav"
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navbar-nav me-auto mb-2 mb-md-0 derecha">
            <section
              style={{ display: "flex", justifyContent: "flexEnd", gap: "0.5vw" }}
            >
              {/* 1️⃣ INICIO */}
              <Link
                to="/landing"
                className={`nav-link linkNavBar ${
                  isInicio ? "linkNavBarActive" : ""
                }`}
                style={{ fontSize: "14px" }}
              >
                Inicio
              </Link>

              {/* 2️⃣ BEAUTISALON */}
              <Dropdown
                className="dropdownBeautisalon"
                show={showBeautisalon}
                onToggle={(open) => setShowBeautisalon(open)}
                onMouseEnter={() => setShowBeautisalon(true)}
                onMouseLeave={() => setShowBeautisalon(false)}
              >
                <Dropdown.Toggle
                  className={`nav-link linkNavBar dropdownBeautisalonToggle ${
                    isBeautisalon ? "linkNavBarActive" : ""
                  }`}
                  style={{ fontSize: "14px" }}
                >
                  Beauti Salon
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdownBeautisalonMenu">
                  <Dropdown.Item as={Link} to="/cartilla/nails" className="dropdownBeautisalonItem">
                    Nails
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/cartilla/minibeautiqueras" className="dropdownBeautisalonItem">
                    Mini beautiqueras
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/cartilla/beautibox" className="dropdownBeautisalonItem">
                    Beautibox
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/cartilla/w&e" className="dropdownBeautisalonItem">
                    Events | Workshops
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* 3️⃣ TIENDA ONLINE */}
              {!editMode && (
                <a
                  href="https://labeautiqueriamarket.mitiendanube.com/"
                  className="nav-link linkNavBar"
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontSize: "14px" }}
                >
                  Tienda Online
                </a>
              )}

              {/* 4️⃣ BEAUTI COMUNIDAD */}
              <Link
                to="/alianzas"
                className={`nav-link linkNavBar ${
                  isBeautiComunidad ? "linkNavBarActive" : ""
                }`}
                style={{ fontSize: "14px" }}
              >
                Beauti Comunidad
              </Link>

              {/* 5️⃣ CONTACTO */}
              <Link
                to="/contacto"
                className={`nav-link linkNavBar ${
                  isContacto ? "linkNavBarActive" : ""
                }`}
                style={{ fontSize: "14px" }}
              >
                Contacto
              </Link>

              {/* USUARIO / LOGIN */}
              {user.role !== undefined ? (
                <DropdownButton
                  className="dropdowncito dropNav"
                  title={titleDrop()}
                >
                  <div className="container-items">
                    <Link className="link-drop" to="/perfil">
                      Mi perfil
                    </Link>
                    <Dropdown.Item
                      className="link-drop"
                      onClick={cerrarSesion}
                    >
                      Cerrar sesión
                    </Dropdown.Item>
                  </div>
                </DropdownButton>
              ) : (
                <div className="iniciarSesion">
                  <Link to="/iniciarSesion" className="iniciarSesionLink">
                    <button className="iniciarSesionButton">
                      Iniciar Sesión
                    </button>
                  </Link>
                </div>
              )}
            </section>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default NavBarRosa;
